import React from "react";

const MessageFatsuSkeleton: React.FC = () => {
  return (
    <>
      <div className="min-h-[calc(100vh-275px)]">
        <section className="section relative text-white py-10 pb-0 max-sm:py-6 max-sm:px-4 blue-bg-dots z-[1]">
          <div className="container max-sm:!px-0">
            <h2 className="text-lightBlue text-6xl max-md:text-4xl max-sm:text-3xl text-start mb-8 max-sm:mb-6 break-all">
              <div className="h-14 max-sm:h-8 max-sm:w-full w-96 max-md:w-56 bg-gray-300 skeleton rounded"></div>
            </h2>
            <div className="flex max-md:block justify-start max-md:grid-cols-1">
              <div className="max-w-[315px] max-h-[500px] min-h-[500px] size-full max-sm:mx-auto">
                <div className="max-h-[500px] min-h-[500px] size-full bg-gray-300 skeleton rounded"></div>
              </div>

              <div className="w-3/4 max-md:w-full my-4">
                <div className="text-[32px] max-md:text-2xl max-sm:text-lg bg-[#3b23b344] text-start shadow-black p-6">
                  <div>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map(
                      (item) => {
                        return (
                          <div
                            key={item}
                            className="skeleton w-full h-6 my-5 !rounded-md"
                          ></div>
                        );
                      }
                    )}
                  </div>
                </div>
                <div className="max-h-[300px] min-h-[300px] size-full">
                  <div className="max-h-[300px] min-h-[300px] size-full bg-gray-300 skeleton rounded"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default MessageFatsuSkeleton;
